 <template>
  <div class="app-mercedes">
    <div>
      <nav
        class="navbar navbar-light navbar-expand-lg p-0 border-0 shadow"
        style="background: #212121;height:50px"
      >
        <div class="container">
          <a href class="navbar-brand router-link-active" style="display:flex">
            <img :src="peu" width="40px" alt />
            <span style="padding-left:1rem;border-right: 1px solid #fff;"></span>
            <span style="padding-left:1rem;"></span>
            <router-link to="/peugeot" style="margin-top: auto;margin-bottom: auto;">
              <img :src="commer" width="110px" alt style="cursor:pointer" />
            </router-link>
            <span style="padding: 0.5rem 1rem 0rem 1rem"></span>
          </a>
        </div>
      </nav>
    </div>
    <!-- banner -->
    <section class="passdetailslider">
      <el-carousel :interval="5000" arrow="never">
        <el-carousel-item
          v-for="item in 1"
          :key="item"
          :style="{backgroundImage: ' linear-gradient(270deg, #00000000 0%, #000000 100%),url('+banner+')'}"
        >
          <div class="container">
            <div class="row">
              <div class="sliderinfo">
                <h5>
                  The all new
                  <span>{{pageTitle}}</span>
                </h5>
                <div class="line"></div>
                <!-- <h2>{{details.name}}</h2>
                <p >The Arocs up to 250 tonnes sets benchmarks in comfort, vehicle performance and flexibility in the heavy-duty transport sector.</p>-->
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>
    <div class="cdetails">
      <div class="container">
        <!-- <div class="row py-5">
          <div class="col-sm-6 col-md-7 col-lg-7" style="margin-top:1rem">
            <h3 class="detailstitle" v-html="bannertitle"></h3>
          </div>
          <div class="col-sm-6 col-md-5 col-lg-5 detailsinfo" style="margin-top:1rem">
            <p v-html="subtext"></p>
          </div>
        </div>-->
        <div class="py-5">
          <div class="featured-article-block">
            <div style="width:105px;height:84px">
              <a outlined 
   :href="this.book"
   target="_blank"
   download>
                <img
                  :src="this.banner"
                  alt
                  class="thumbnail-small"
                  style="max-width:100%; 
            border-radius:8px;position:relative;top:0; left:0;max-height:100%"
                />
                <span
                  class="ti-download downloadicon"
                  style="width:30px;position:absolute; margin-left: -3.5%;margin-top:2%;color:white;font-size:1.5rem"
                ></span>
              </a>
            </div>

            <div class="div-block"></div>
            <div class="pt-3">
              <div>ONLINE BROCHURE</div>
              <div style="text-transform:uppercase;font-size:25px">{{pageTitle}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-5" style="margin:1rem 0rem">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-6 col-lg-6">
            <!-- <div class="trialbox"><img :src="trial" alt="" width="500px"></div> -->
            <div>
              <div class="product-image-container">
                <div class="product-carousel owl-carousel" data-slider-id="1">
                  <div class v-for="(thumb, i) in carimgs" :key="i" style="height:250px">
                    <a :href="thumb.image" class="fancybox" data-fancybox="images">
                      <img :src="thumb.image" class="img-fluid" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-image-container d-none d-md-block">
              <div data-slider-id="1" class="owl-thumbs flex-column">
                <button
                  class="owl-thumb-item"
                  v-for="(thumb, i) in carimgs.slice(0,6) "
                  :key="i"
                  style="background-color: rgb(246, 246, 246);"
                >
                  <img :src="thumb.image" />
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="productdetails py-3">
              <h5>
                <a
                  class="active"
                  data-toggle="collapse"
                  href="#multiCollapseExample10"
                  role="button "
                  aria-expanded="false"
                  aria-controls="multiCollapseExample10"
                  @click="changeicon"
                >
                  <i class="ti-minus" style="float:right"></i>PRODUCT DETAILS
                </a>
              </h5>
              <div class="collapse multi-collapse show" id="multiCollapseExample10">
                <!-- {{details}} -->
                <p v-html="description"></p>
                <div style="margin-top:4%"></div>
              </div>
            </div>
            <div class="py-3">
              <h5>
                <a
                  class="active"
                  data-toggle="collapse"
                  href="#multiCollapseExample11"
                  role="button "
                  aria-expanded="false"
                  aria-controls="multiCollapseExample11"
                  @click="changeicon"
                >
                  <i class="ti-plus" style="float:right;display:none"></i>
                </a>
              </h5>
              <div class="collapse multi-collapse" id="multiCollapseExample11">
                <p v-html="technicalinfo" style="display;none"></p>
              </div>
            </div>
            <div class="py-3" style="display:none">
              <h5>
                <a
                  class
                  data-toggle="collapse"
                  href="#multiCollapseExample12"
                  role="button "
                  aria-expanded="false"
                  aria-controls="multiCollapseExample12"
                  @click="changeicon"
                >DELIVERY & RETURNS</a>
                <span>
                  <i class></i>
                </span>
              </h5>
              <div class="collapse multi-collapse" id="multiCollapseExample12">
                <p v-html="details.deliveryinfo "></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- youtube link -->
    <div class="py-5" style="margin:1rem 0rem" v-if="videoId">
      <div class="container">
        <div class="row">
          <div class="col-md-10 offset-md-1 text-center" style="overflow:hidden">
            <youtube :video-id="videoId" style="max-width:100%"></youtube>
          </div>
        </div>
      </div>
    </div>
    <!-- latest news -->
    <!-- discover -->
    <!-- <div class="my-5">
      <div class="container">
        <div class style>
          <div class="py-5 text-center">
           
            <p class="discovermess" v-html="details.footertitle"></p>
          </div>
        </div>

        <div class="row pb-4">
          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img :src="footerimga" width="100%" height="100%" />
            </div>
            <div class="boxcontents">
              <p v-html="footera"></p>
            </div>
          </div>

          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img :src="footerimgb" width="100%" height="100%" />
            </div>
            <div class="boxcontents">
              <p v-html="footerb"></p>
            </div>
          </div>

          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img :src="footerimgc" width="100%" height="100%" />
            </div>
            <div class="boxcontents">
              <p v-html="footerc"></p>
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <div class="bg-grey" style="padding-top:3rem">
      <div class="container">
        <core></core>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CoreValues from "../../components/Core.vue";
import { peugeot_cars } from "../../config";
var peu = require("../../assets/img/benz.png");
var sep = require("../../assets/img/peulogo.png");
var model = require("../../assets/img/model.png");
var commer = require("../../assets/img/passen.svg");
var comfort = require("../../assets/img/comfort.png");
var trial = require("../../assets/img/trial.png");
var car1 = require("../../assets/img/teaser.png");
var car2 = require("../../assets/img/teasergenuine.png");
var car3 = require("../../assets/img/teasermultimedia.png");

import VueYouTubeEmbed from "vue-youtube-embed";

export default {
  name: "PeugeotDetails",
  components: {
    core: CoreValues,

    VueYouTubeEmbed
  },
  data() {
    return {
      peu,
      sep,
      commer,
      comfort,
      model,
      car1,
      car2,
      car3,
      trial,
      comcars: peugeot_cars,
      details: [],
      carimgs: [],
      pageTitle: "",
      banner: "",
      book:"",
      link: "",
      technicalinfo: "",
      description: "",
      bannertitle: "",
      subtext: "",
      footera: "",
      footerb: "",
      footerc: "",
      footerd: "",
      footerimga: "",
      footerimgb: "",
      footerimgc: "",
      carimgs: "",

      videoId: 0
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
      technicalinfo: this.technicalinfo
    };
  },
  computed: {},
  methods: {
    pass() {
      this.$router.push("/mercedes/passenger");
    },
    changeicon() {
      if (
        $(".collapse").on("shown.bs.collapse", function() {
          console.log("me this 4");
          $(this)
            .parent()
            .find(".ti-plus")
            .removeClass("ti-plus")
            .addClass("ti-minus");
        })
      );
      if (
        $(".collapse").on("hidden.bs.collapse", function() {
          console.log("me this oo");
          $(this)
            .parent()
            .find(".ti-minus")
            .removeClass("ti-minus")
            .addClass("ti-plus");
        })
      );
    },
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    fetchCarDetails() {
      //hide minus icon  minus

      let url, mask;
      mask = this.$route.params.mask;
      url = this.$route.params.producturl;

      this.pageTitle = url;
      //  alert(this.pageTitle);
      // var result = jQuery.parseJSON(this.comcars);
      // alert(this.comcars);
      //  alert(this.comcars[mask].technicalinfo);
      this.technicalinfo = this.comcars[mask].technicalinfo;
      this.banner = this.comcars[mask].banner;
      this.book = this.comcars[mask].book;
      this.description = this.comcars[mask].description;
      this.bannertitle = this.comcars[mask].bannertitle;
      this.subtext = this.comcars[mask].subtext;
      this.footera = this.comcars[mask].footera;
      this.footerb = this.comcars[mask].footerb;
      this.footerc = this.comcars[mask].footerc;
      this.footerd = this.comcars[mask].footerd;
      this.footerimga = this.comcars[mask].footerimga;
      this.footerimgb = this.comcars[mask].footerimgb;
      this.footerimgc = this.comcars[mask].footerimgc;
      this.carimgs = this.comcars[mask].carimage;

      //  alert(this.book)

      // axios
      //   .get(APIURL + "product/" + url + "/" + mask)

      //   .then(response => {
      //     if (response.data.status == 200) {
      //       this.details = response.data.data;
      //       this.carimgs = this.details.images;
      //       this.banner= this.details.banner;
      //       this.link = this.details.youtubelink;
      //       console.log(this.banner);

      this.$nextTick(function() {
        $(".fancybox").fancybox();
        $(".product-carousel").owlCarousel({
          loop: false,
          items: 1,
          responsiveClass: true,
          autoplayHoverPause: false,
          startPosition: 0,
          thumbs: true,
          autoplay: false,
          thumbImage: false,
          // Enable this if you have pre-rendered thumbnails in your html instead of letting this plugin generate them. This is recommended as it will prevent FOUC
          thumbsPrerendered: true,
          // Class that will be used on the thumbnail container
          thumbContainerClass: "owl-thumbs",

          // Class that will be used on the thumbnail item's
          thumbItemClass: "owl-thumb-item"
        });
      });
      //        this.videoId = this.$youtube.getIdFromURL(this.link);

      // }
      //});
    }
  },
  created() {
    this.fetchCarDetails(), this.changeicon();
  }
};
</script>
